import { AppState } from './../../shared/app-state.container';
import { DashboardService } from './../../core/services/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HotelHeaderInfo } from './../../core/store/general/state';
import { SingleResultService } from './../../core/services/single-hotel.service';
import { Observable, of, Subject, forkJoin } from 'rxjs';
import { IMarker } from './../../shared/components/map/map.component';
import { IRequest } from './../../core/models/request';
import { getBookingAction, getUserInfo, isRequestSendingEnabled } from './../../core/store/general/selectors';
import {
    HeaderChangeAction, ChangeLasteRequestAsked,
    ChangeHotelInfo, ChangeLoadingStatusAction, ToggleLoginModal, ChangeBookingAction,
    SendRequest
} from './../../core/store/general/actions';
import { SortByOptions } from './../../core/models/general.model';
import { ResultsService } from './../../core/services/results.service';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Hotelier } from '../../core/models/results/offer.model';
declare const fbq: any;
@Injectable()
export class ResultsContainer {

    public totalCurrentOffers: Number = 0;

    public sentRequest: boolean;

    public isLoggedIn$;
    public userLoggedIn;
    public header$;
    public hotelTypes$;
    public mealTypes$;
    public exclusiveCategories$;
    public optionalFacilities$;
    public priceRange$ = {
        minPrice: 1000,
        maxPrice: 0
    };
    hotePreviews: Array<HotelPreview>;
    public hotePreviewsForMaps: Array<HotelPreview>;
    public hotelPreviewsForOffers: Array<HotelPreview>;
    allHotels: Array<HotelPreview>;
    public myRequestInfo: IRequest;
    public markers: Array<IMarker>;
    hotels: Array<any>;
    bookingRequest;
    userLoggedInAfter = false;
    public selectedExperiences = new Array();

    public hotelPrev = new Subject<Array<HotelPreview>>();
    public hotelPreviewsArr$ = this.hotelPrev.asObservable();

    public markersSubj = new Subject<Array<IMarker>>();
    public markersArr$ = this.markersSubj.asObservable();

    public sortBySubj = new Subject<Array<any>>();
    public sortBy$ = this.sortBySubj.asObservable();
    experiencesIconsMapping;
    public requestId;
    roomsForBooking;
    offerInfo;
    offerId;
    currentTotalCost;

    public svgPhase = false;
    public hasSeenAnimation = false;
    public playAnimation = true;
    public mailModalSeen: Boolean = false;

    i: any = 1;

    requestForSearch;
    constructor(
        protected sharedContainer: AppState,
        private resultsService: ResultsService,
        private singleResultService: SingleResultService,
        private router: Router,
        private dashboard: DashboardService,
        protected location: Location,
        protected route: ActivatedRoute
    ) {
        this.experiencesIconsMapping = new Map([
            [1, '../../../../assets/img/icons/leisure.svg'],
            [2, '../../../../assets/img/icons/beach-sun.svg'],
            [3, '../../../../assets/img/icons/relax.svg'],
            [4, '../../../../assets/img/icons/family.svg'],
            [5, '../../../../assets/img/icons/budget-save-sun.svg'],
            [6, '../../../../assets/img/icons/luxury.svg'],
            [7, '../../../../assets/img/icons/local-gastronomy.svg'],
            [8, '../../../../assets/img/icons/local-culture.svg'],
            [9, '../../../../assets/img/icons/Experience-local-way-of-life.svg'],
            [10, '../../../../assets/img/icons/spa-wellness.svg'],
            [11, '../../../../assets/img/icons/Beauty-services.svg'],
            [12, '../../../../assets/img/icons/romance.svg'],
            [13, '../../../../assets/img/icons/wedding.svg'],
            [14, '../../../../assets/img/icons/anniversary.svg'],
            [15, '../../../../assets/img/icons/bussiness-travel.svg'],
            [16, '../../../../assets/img/icons/conference.svg'],
            [17, '../../../../assets/img/icons/exhibitions.svg'],
            [18, '../../../../assets/img/icons/nightlife.svg'],
            [19, '../../../../assets/img/icons/car-moto-hire.svg'],
            [20, '../../../../assets/img/icons/taxi.svg'],
            [21, '../../../../assets/img/icons/tours.svg'],
            [22, '../../../../assets/img/icons/water-sports.svg'],
            [23, '../../../../assets/img/icons/outdoor-activities.svg'],
            [24, '../../../../assets/img/icons/Archeological-sights.svg'],
            [25, '../../../../assets/img/icons/nature-parks.svg'],
            [26, '../../../../assets/img/icons/shopping.svg'],
            [27, '../../../../assets/img/icons/events-concerts.svg'],
            [28, '../../../../assets/img/icons/classes-workshops.svg'],
            [29, '../../../../assets/img/icons/agricultural-experience.svg'],
            [30, '../../../../assets/img/icons/casino-Gambling.svg'],
            [31, '../../../../assets/img/icons/Zoos-Aquariums.svg'],
            [32, '../../../../assets/img/icons/medical-tourism.svg'],
        ]);
        this.hotelTypes$ = new Map<number, string>();
        this.mealTypes$ = new Map<number, string>();
        this.exclusiveCategories$ = new Map<number, string>();
        this.optionalFacilities$ = new Map<number, string>();
        this.hotePreviews = new Array<HotelPreview>();
        this.allHotels = new Array<HotelPreview>();
        this.markers = new Array<IMarker>();
        this.hotels = new Array<any>();

        /*this.route.queryParams.subscribe(val => {
            if (val.sortby === 'high_to_low') {
                this.sortHotelsBy();
            }
        });*/

        /*this.sharedContainer.generalState$.select(getSortByOption)
            .subscribe(sortByOption => {
                alert('sorted hotels by: ' + sortByOption);
                this.sortHotelsBy(sortByOption);
            });*/

        this.isLoggedIn$ = this.sharedContainer.isLoggedIn$;

        // this.sharedContainer.userLoggedIn$.subscribe(reply => this.userLoggedInAfterRequest());

        // this.sharedContainer.generalState$.select(getUserInfo)
        // .subscribe(request => {
        //     this.userLoggedInAfterRequest();
        // });
        // this.priceRange$.maxPrice = 1000 ;
        this.sharedContainer.generalState$.select(isRequestSendingEnabled).subscribe(opened => {
            if (opened === true) {
                this.userLoggedInAfter = true;
                // this.sharedContainer.generalState$.dispatch(new ToggleLoginModal(1, {loginModalOpened: false}));
                this.sharedContainer.generalState$.dispatch(new SendRequest(1,
                    { isRequestSendEnabled: false }));
            }
        });

        this.getUserInformation().subscribe(user => {
            this.userLoggedIn = user;
            this.userLoggedInAfterRequest();
        });

        this.sentRequest = false;

    }

    getUserInformation() {
        return this.sharedContainer.generalState$.select(getUserInfo);
    }

    storeOffersNew(offers, isFirst, requestForSearch) {
        this.hotePreviews = new Array<HotelPreview>();
        this.markers = new Array<IMarker>();
        offers.offers.map(offer => {
            if (offer.offer === null) { return; }
            // this.fillFilterOptions(offer);
            this.fillRequestInfoNew(requestForSearch);

            this.requestForSearch = requestForSearch;
            this.hotePreviews.push(this.fillHotelPreviewInfoNew(offer, false));
            this.fillMinMaxPriceNew(requestForSearch);
        });
        if (isFirst) {
            this.fillSelectedExperiences();
        }
        this.hotelPrev.next(this.hotePreviews);

        this.allHotels = Array.from(this.hotePreviews);

    }
    storeOffersForOffers(offers) {
        if (offers.offers.length > 0) { this.svgPhase = true; this.hasSeenAnimation = true; }
        if (offers.offers.length === this.totalCurrentOffers && this.hotelPreviewsForOffers !== undefined) {
            if (this.hotelPreviewsForOffers === null) { return; }
            offers.allOfferIds.forEach(e => {
                this.hotePreviews.forEach(e1 => {
                    if (e1.id === e) {
                        const index: number = this.hotePreviews.indexOf(e1);
                        if (index !== -1) {
                            this.hotePreviews.splice(index, 1);
                        }
                    }
                });
            });

        }
        this.hotelPreviewsForOffers = new Array<HotelPreview>();
        offers.offers.map(offer => {
            if (offer.offer === null) { return; }
            this.hotelPreviewsForOffers.push(this.fillHotelPreviewInfoNew(offer, true));
        });
        // probable fix for duplicate offers at same result page???
        /* offers.allOfferIds.forEach(e => {
            this.hotePreviews.forEach(e1 => {
                if (e1.id === e) {
                    const index: number = this.hotePreviews.indexOf(e1);
                    if (index !== -1) {
                        this.hotePreviews.splice(index, 1);
                    }
                }
            });
        });*/
        this.hotelPrev.next(this.hotePreviews);
        // this.markersSubj.next(this.markers);
        this.totalCurrentOffers = offers.offers.length;

        this.allHotels = Array.from(this.hotePreviews);

        /* this.route.queryParams.subscribe(params => {
            if (params.sortby) {
                if (params.sortby === 'high_to_low') {
                    this.hotelPreviewsForOffers.sort((a, b) => {
                        return b.minPrice - a.minPrice;
                    });
                } else {
                    this.hotelPreviewsForOffers.sort((a, b) => {
                        return a.minPrice - b.minPrice;
                    });
                }
            }
        }); */

    }
    filterOffersByExp(filter) {
        if (this.hotelPreviewsForOffers.length > 1) {
            this.hotelPreviewsForOffers.forEach(prev => {
                prev.filterMatch = false;
                if (prev.experiences.length > 0) {
                    prev.experiences.forEach(exp => {
                        if (exp.optionalExtraCategory.category === filter) {
                            prev.filterMatch = true;
                        }
                    });
                }
            });
        }
        setTimeout(() => {
            this.hotelPreviewsForOffers.sort((a, b) => {
                return (a.filterMatch === b.filterMatch) ? 0 : a ? 1 : -1;
            });
        }, 500);
    }
    storeOffersForMaps(offers) {
        this.markers = new Array<IMarker>();
        offers.map(offer => {
            this.hotePreviewsForMaps.push(this.fillHotelPreviewInfoNew(offer, false));
            this.fillMarkers(offer.hotel, false);
        });
        this.markersSubj.next(this.markers);
    }
    storeOffersForMapsPR(offers) {
        offers.offers.forEach(offer => {
            this.hotePreviewsForMaps.push(this.fillHotelPreviewInfoNew(offer, true));
            this.fillMarkers(offer.hotel, true);
        });
        this.markersSubj.next(this.markers);
    }
    storeOffers(offers, isFirst) {
        if (isFirst) {
            this.hotePreviews = new Array<HotelPreview>();
            this.markers = new Array<IMarker>();
        }
        offers.offers.map(offer => {
            if (offer.offer === null) { return; }
            this.fillFilterOptions(offer);
            this.fillRequestInfo(offer.offer.bookingRequest);

            this.hotePreviews.push(this.fillHotelPreviewInfo(offer));
            this.sortByPrice('DESC');
            // this.sortByExperiences();
            this.bookingRequest = offer.offer.bookingRequest;
            this.fillMinMaxPrice(offer.offer.bookingRequest);
            this.fillMarkers(offer.hotel, false);
        });
        this.fillSelectedExperiences();
        this.hotelPrev.next(this.hotePreviews);
        this.markersSubj.next(this.markers);

        this.allHotels = Array.from(this.hotePreviews);

    }

    subscribeToBookingEvent(): Observable<any> {
        return this.sharedContainer.generalState$.select(getBookingAction);
    }


    fillMarkers(hotel, isOffer) {
        const marker: IMarker = {
            lat: hotel.latitude, lng: hotel.longitude,
            draggable: false, label: hotel.id, type: isOffer ? 'Offer' : 'Hotel'
        };
        this.markers.push(marker);
    }

    fillRequestInfoNew(bookingRequest) {
        const persons = [bookingRequest.adults, bookingRequest.children];
        this.myRequestInfo = {
            location: null, latitude: null,
            longitude: null, fromdate: bookingRequest.fromdate,
            todate: bookingRequest.todate, maxprice: bookingRequest.totalprice,
            minprice: null, rooms: bookingRequest.rooms,
            roompersons: persons, roomLift: null,
            disableAccess: null, smoking: null,
            roomLiftOpt: null, disableAccessOpt: null,
            smokingOpt: null, starRating: -1, accomType: -1, mealType: -1,
            personalReq: null, requestExpiry: null,
            hotelfacilities: '', hotelroomfacilities: '', opthotelfacilities: '',
            opthotelroomfacilities: '',
            hotelextras: bookingRequest.hotelextras,
            userid: bookingRequest.offerid !== null ? bookingRequest.offerid : null
        };
        // this.sharedContainer.generalState$.dispatch(new ChangeLasteRequestAsked(1, {lastRequestAsked: this.myRequestInfo}));
    }

    fillRequestInfo(bookingRequest) {
        this.myRequestInfo = {
            location: bookingRequest.destination, latitude: bookingRequest.latitude,
            longitude: bookingRequest.longitude, fromdate: bookingRequest.fromDate,
            todate: bookingRequest.toDate, maxprice: bookingRequest.priceRange,
            minprice: bookingRequest.priceRangeMin, rooms: bookingRequest.noOfRooms,
            roompersons: JSON.parse(bookingRequest.roomPersons), roomLift: bookingRequest.liftOrStairs,
            disableAccess: bookingRequest.handicapAccess, smoking: bookingRequest.smokingRoom,
            roomLiftOpt: bookingRequest.liftOrStairsOpt, disableAccessOpt: bookingRequest.handicapAccessOpt,
            smokingOpt: bookingRequest.smokingRoomOpt, starRating: -1, accomType: -1, mealType: -1,
            personalReq: bookingRequest.personalRequest, requestExpiry: bookingRequest.expiryDate,
            hotelfacilities: '', hotelroomfacilities: '', opthotelfacilities: bookingRequest.bookingRequestPropertyCollection,
            opthotelroomfacilities: bookingRequest.bookingRequestFacilityCollection,
            hotelextras: bookingRequest.bookingRequestExtrasCollection,
            userid: bookingRequest.user !== null ? bookingRequest.user.id : null
        };
        this.sharedContainer.generalState$.dispatch(new ChangeLasteRequestAsked(1, { lastRequestAsked: this.myRequestInfo }));
    }

    fillSelectedExperiences() {
        // if (this.selectedExperiences.length > 0) { return; }
        /*if (!this.myRequestInfo) {
            this.goBack();
            alert('No Villas Found. Please, change your criteria and try again :)');
            return;
        }*/
        this.selectedExperiences = [];
        if (this.requestForSearch.hotelextras) {
            /* this.requestForSearch.hotelextras.forEach(experience => {
              let exp;
              let i = 0;
              exp = {
                id: parseInt(experience, 10),
                icon: this.experiencesIconsMapping.get(parseInt(experience, 10))
              };
              // exp.title = this.requestForSearch.experiencestitle[i];
              i++;
              this.selectedExperiences.push(exp);
            });*/
            for (let j = 0; j < this.selectedExperiences.length; j++) {
                this.selectedExperiences[j].title = this.requestForSearch.experiencestitle[j];
            }
        }
    }

    fillFilterOptions(offer) {
        this.fillHotelTypes(offer.hotel.hotelAccommocationTypeCollection);
        this.fillMealTypes(offer.hotel.hotelMealCollection);
        this.fillExclusiveCategories(offer.offer.bookingOfferOptionalExtrasCollection);
        this.fillOptionalFacilities(offer.offer.bookingOfferFacilitiesCollection);
        // this.fillMinMaxPrice(offer.offer.bookingOfferRoomCollection);
    }

    pad(n) {
        return n < 10 ? '0' + n : n;
    }

    msToDhm(t) {
        if (t > 0) {
            const cd = 24 * 60 * 60 * 1000,
                ch = 60 * 60 * 1000;
            let d = Math.floor(t / cd),
                h = Math.floor((t - d * cd) / ch),
                m = Math.round((t - d * cd - h * ch) / 60000);
            if (m === 60) {
                h++;
                m = 0;
            }
            if (h === 24) {
                d++;
                h = 0;
            }
            return { days: d, hours: this.pad(h), minutes: this.pad(m) };
        } else {
            return { days: 0, hours: '00', minutes: '00' };
        }
    }

    fillHotelPreviewInfoNew(offer, isOffer): HotelPreview {
        const hotelPreview: HotelPreview = {
            minPrice: 10000,
            minDefaultPrice: 10000,
            title: '',
            description: '',
            pictures: [],
            stars: -1,
            reviews: 0,
            experiences: [],
            experiencesSortByAPrice: [],
            optionaRequests: [],
            id: -1,
            offerId: -1,
            offerType: '',
            experiencesAvailable: '',
            optionalAvailable: '',
            hasDiscount: false,
            wishesSatisfied: '',
            hotelierName: '',
            hotelier: null,
            isAvailable: false
        };
        hotelPreview.lat = offer.hotel.latitude;
        hotelPreview.long = offer.hotel.longitude;
        hotelPreview.title = offer.hotel.name;
        hotelPreview.stars = offer.hotel.starRating;
        hotelPreview.id = offer.hotel.id;
        hotelPreview.offerId = offer.hotel.id;
        hotelPreview.pictures = offer.propertyPics;
        hotelPreview.wishesSatisfied = offer.wishesSatisfied;
        hotelPreview.description = offer.hotel.description;
        hotelPreview.isAvailable = offer.isAvailable;
        isOffer ? hotelPreview.offerType = 'Offer' : hotelPreview.offerType = 'Hotel';
        isOffer ? hotelPreview.minPrice = offer.offer.price : hotelPreview.minPrice = offer.dailyPrice;
        isOffer ? hotelPreview.minDefaultPrice = offer.dailyCharge : hotelPreview.minDefaultPrice = offer.dailyPrice;
        if (isOffer) {
            hotelPreview.hotelierName = offer.hotel.contactPerson;
            hotelPreview.hotelier = offer.hotelier;
        }
        if (hotelPreview.offerType === 'Offer') {
            const dateNow = new Date().getMilliseconds();
            let delta = (parseInt(offer.offer.expiryDate, 10) - dateNow) / 1000;

            const days = Math.floor(delta / 86400000);
            delta -= days * 86400000;

            const hours = Math.floor(delta / 3600000) % 24;
            delta -= hours * 3600000;

            const minutes = Math.floor(delta / 60000) % 60;
            delta -= minutes * 60000;

            const exp = {
                days: days,
                hours: hours,
                minutes: minutes
            };
            const d = new Date();
            hotelPreview.expiring = this.msToDhm(offer.offer.expiryDate - new Date().getTime());
        }
        if (hotelPreview.pictures[0]) {
            hotelPreview.pictures[0].preloaded = true; // f load first image only
        }
        hotelPreview.experiences = offer.extras;
        hotelPreview.experiences.forEach(experience => {
            if (experience.optionalExtraCategory) {
                /*if (hotelPreview.requestInfo.hotelextras) {
                  const item = hotelPreview.requestInfo.hotelextras
                    .find(facility => facility.bookingExtraCategory.id === experience.optionalExtraCategory.id ? true : false
                    );
                  item ? experience.hasTick = true : experience.hasTick = false;
                }*/
                experience.icon = this.experiencesIconsMapping.get(experience.optionalExtraCategory.id);
            } else {
                experience.icon = this.experiencesIconsMapping.get(12);
            }

        });

        hotelPreview.experiences.sort((a, b) => {
            if (a.hasTick === true && b.hasTick === false) {
                return -1;
            }

            if (a.hasTick === false && b.hasTick === true) {
                return 1;
            }

            return 0;
        });
        hotelPreview.experiencesSortByAPrice = JSON.parse(JSON.stringify(hotelPreview.experiences));

        hotelPreview.experiencesSortByAPrice.sort((a, b) => {
            if (a.isFree === true && b.isFree === false) {
                return -1;
            }

            if (a.isFree === false && b.isFree === true) {
                return 1;
            }

            if (a.isCategoryMeal === true && b.isCategoryMeal === false) {
                return -1;
            }
            if (a.isCategoryMeal === false && b.isCategoryMeal === true) {
                return 1;
            }

            return 0;
        });
        if (hotelPreview.offerType === 'Offer') {
            if (offer.offer.personalRequestResponse !== null) {
                if (offer.hotelier) {
                    const offernote = {
                        text: offer.offer.personalRequestResponse,
                        image: 'data:image/png;base64,' + offer.hotelier.picture
                    };
                    hotelPreview.offerNote = offernote;
                } else {
                    const offernote = {
                        text: offer.offer.personalRequestResponse,
                        image: ''
                    };
                    hotelPreview.offerNote = offernote;
                }
            }
        }
        /*if (hotelPreview.minDefaultPrice !== hotelPreview.minPrice) {
          hotelPreview.hasDiscount = true;
        }*/
        // hotelPreview.minPrice = offer.offer.price;
        // hotelPreview.minDefaultPrice = offer.offer.price;
        if (isOffer) {
            offer.offer.bookingOfferRoomCollection.map(room => {
                if (room.availableRooms > 0) {
                    if (room.defaultPrice > room.offerPrice) {
                        hotelPreview.minPrice = room.offerPrice;
                        hotelPreview.minDefaultPrice = room.defaultPrice;
                        hotelPreview.hasDiscount = true;
                    }
                    /*if (hotelPreview.minPrice > room.offerPrice) {
                      hotelPreview.minPrice = room.offerPrice;
                      hotelPreview.minDefaultPrice = room.defaultPrice;
                      if (hotelPreview.minDefaultPrice !== hotelPreview.minPrice) {
                        hotelPreview.hasDiscount = true;
                      }
                    }*/
                }
            });
        }
        /*
        hotelPreview.hotelTypes = this.fillHotelTypes(offer.hotel.hotelAccommocationTypeCollection);
        hotelPreview.mealTypes = this.fillMealTypes(offer.hotel.hotelMealCollection);
        hotelPreview.exclusiveCategories = this.fillExclusiveCategories(offer.offer.bookingOfferOptionalExtrasCollection);
        hotelPreview.optionalFacilities = this.fillOptionalFacilities(offer.offer.bookingOfferFacilitiesCollection);*/
        return hotelPreview;
    }

    fillHotelPreviewInfo(offer): HotelPreview {
        const hotelPreview: HotelPreview = {
            minPrice: 10000,
            minDefaultPrice: 10000,
            title: '',
            description: '',
            pictures: [],
            stars: -1,
            reviews: 0,
            experiences: [],
            experiencesSortByAPrice: [],
            optionaRequests: [],
            id: -1,
            offerId: -1,
            offerType: '',
            experiencesAvailable: '',
            optionalAvailable: '',
            hasDiscount: false,
        };
        hotelPreview.lat = offer.hotel.latitude;
        hotelPreview.long = offer.hotel.longitude;
        hotelPreview.title = offer.hotel.name;
        hotelPreview.stars = offer.hotel.starRating;
        hotelPreview.reviews = offer.reviews;
        hotelPreview.pictures = offer.propertyPics;
        hotelPreview.isAvailable = offer.isAvailable;
        if (hotelPreview.pictures[0]) {
            hotelPreview.pictures[0].preloaded = true; // f load first image only
        }
        hotelPreview.experiences = offer.extras;
        hotelPreview.id = offer.hotel.id;
        hotelPreview.offerId = offer.offer.id;
        hotelPreview.offerType = offer.offer.bidType.id === 2 ? 'Offer' : 'Hotel';
        if (hotelPreview.offerType === 'Offer') {
            const dateNow = new Date().getMilliseconds();
            let delta = (parseInt(offer.offer.expiryDate, 10) - dateNow) / 1000;

            const days = Math.floor(delta / 86400000);
            delta -= days * 86400000;

            const hours = Math.floor(delta / 3600000) % 24;
            delta -= hours * 3600000;

            const minutes = Math.floor(delta / 60000) % 60;
            delta -= minutes * 60000;

            const exp = {
                days: days,
                hours: hours,
                minutes: minutes
            };
            const d = new Date();
            hotelPreview.expiring = this.msToDhm(offer.offer.expiryDate - new Date().getTime());
        }

        hotelPreview.requestInfo = this.myRequestInfo;

        hotelPreview.experiences.forEach(experience => {
            if (experience.optionalExtraCategory) {
                if (hotelPreview.requestInfo.hotelextras) {
                    const item = hotelPreview.requestInfo.hotelextras
                        .find(facility => facility.bookingExtraCategory.id === experience.optionalExtraCategory.id ? true : false
                        );
                    item ? experience.hasTick = true : experience.hasTick = false;
                }
                experience.icon = this.experiencesIconsMapping.get(experience.optionalExtraCategory.id);
            } else {
                experience.icon = this.experiencesIconsMapping.get(12);
            }

        });

        hotelPreview.experiences.sort((a, b) => {
            if (a.hasTick === true && b.hasTick === false) {
                return -1;
            }

            if (a.hasTick === false && b.hasTick === true) {
                return 1;
            }

            return 0;
        });
        hotelPreview.experiencesSortByAPrice = JSON.parse(JSON.stringify(hotelPreview.experiences));

        hotelPreview.experiencesSortByAPrice.sort((a, b) => {
            if (a.isFree === true && b.isFree === false) {
                return -1;
            }

            if (a.isFree === false && b.isFree === true) {
                return 1;
            }

            if (a.isCategoryMeal === true && b.isCategoryMeal === false) {
                return -1;
            }
            if (a.isCategoryMeal === false && b.isCategoryMeal === true) {
                return 1;
            }

            return 0;
        });

        if (offer.offer.personalRequestResponse !== null) {
            if (offer.hotelier) {
                const offernote = {
                    text: offer.offer.personalRequestResponse,
                    image: 'data:image/png;base64,' + offer.hotelier.picture
                };
                hotelPreview.offerNote = offernote;
            } else {
                const offernote = {
                    text: offer.offer.personalRequestResponse,
                    image: ''
                };
                hotelPreview.offerNote = offernote;
            }
        }

        if (offer.offer.optExtrasAvail === 1 || offer.offer.optExtrasAvail === 0) {
            hotelPreview.experiencesAvailable = 'icon-no';
            hotelPreview.experiencesPriority = 3;
        } else if (offer.offer.optExtrasAvail === 2) {
            hotelPreview.experiencesAvailable = 'icon-yes';
            hotelPreview.experiencesPriority = 1;
        } else if (offer.offer.optExtrasAvail === 3) {
            hotelPreview.experiencesAvailable = 'icon-some';
            hotelPreview.experiencesPriority = 2;
        }

        if (offer.offer.optFacilitiesAvail === 1 || offer.offer.optFacilitiesAvail === 0) {
            hotelPreview.optionalAvailable = 'icon-no';
            hotelPreview.optFacilitiesPriority = 3;
        } else if (offer.offer.optFacilitiesAvail === 2) {
            hotelPreview.optionalAvailable = 'icon-yes';
            hotelPreview.optFacilitiesPriority = 1;
        } else if (offer.offer.optFacilitiesAvail === 3) {
            hotelPreview.optionalAvailable = 'icon-some';
            hotelPreview.optFacilitiesPriority = 2;
        }

        let num = 0;
        hotelPreview.experiences.forEach(experience => {
            if (hotelPreview.requestInfo.hotelextras) {
                const item = hotelPreview.requestInfo.hotelextras
                    .find(facility => {
                        if (experience.optionalExtraCategory) {
                            if (facility.bookingExtraCategory.id === experience.optionalExtraCategory.id) {
                                return true;
                            }
                        }
                        return false;
                    });
                if (item) { num++; }
            }
        });

        if (num === 0 && hotelPreview.experiences.length === 0) {
            hotelPreview.experiencesPriority = -1;
        } else if (num === 0 && hotelPreview.experiences.length > 0) {
            hotelPreview.experiencesPriority = 0;
        } else {
            hotelPreview.experiencesPriority = num;
        }

        /*
        if (num === hotelPreview.experiences.length &&  hotelPreview.experiences.length > 0) {
            hotelPreview.experiencesPriority = 1;
        } else if (num === 0  && num === hotelPreview.experiences.length) {
            hotelPreview.experiencesPriority = 100;
        } else {
            hotelPreview.experiencesPriority = 2;
        }*/


        // hotelPreview.minPrice = offer.offer.price;
        // hotelPreview.minDefaultPrice = offer.offer.price;
        offer.offer.bookingOfferRoomCollection.map(room => {
            if (room.availableRooms > 0) {
                if (hotelPreview.minPrice > room.offerPrice) {
                    hotelPreview.minPrice = room.offerPrice;
                    hotelPreview.minDefaultPrice = room.defaultPrice;
                    if (hotelPreview.minDefaultPrice !== hotelPreview.minPrice) {
                        hotelPreview.hasDiscount = true;
                    }
                }
            }
        });

        hotelPreview.hotelTypes = this.fillHotelTypes(offer.hotel.hotelAccommocationTypeCollection);
        hotelPreview.mealTypes = this.fillMealTypes(offer.hotel.hotelMealCollection);
        hotelPreview.exclusiveCategories = this.fillExclusiveCategories(offer.offer.bookingOfferOptionalExtrasCollection);
        hotelPreview.optionalFacilities = this.fillOptionalFacilities(offer.offer.bookingOfferFacilitiesCollection);
        return hotelPreview;
    }


    fillHotelTypes(accommodationTypes) {
        const hotelTypes = new Map(); // for a single hotel
        if (accommodationTypes === null) { return hotelTypes; }
        accommodationTypes.map(accomodation => {
            if (!this.hotelTypes$.has(accomodation.accommodationType.id)) {
                this.hotelTypes$.set(accomodation.accommodationType.id, accomodation.accommodationType.name);
            }
            if (!hotelTypes.has(accomodation.accommodationType.id)) {
                hotelTypes.set(accomodation.accommodationType.id, accomodation.accommodationType.name);
            }
        }
        );
        return hotelTypes;
    }

    fillMealTypes(mealTypes) {
        const mealtypes = new Map(); // for a single hotel
        if (mealTypes === null) { return mealtypes; }
        mealTypes.map(accomodation => {
            if (!this.mealTypes$.has(accomodation.mealType.id)) {
                this.mealTypes$.set(accomodation.mealType.id, accomodation.mealType.mealType);
            }
            if (!mealtypes.has(accomodation.mealType.id)) {
                mealtypes.set(accomodation.mealType.id, accomodation.mealType.mealType);
            }
        }
        );
        return mealtypes;
    }

    fillExclusiveCategories(exclusive) {
        const exclusiveCats = new Map(); // for a single hotel
        if (exclusive === null) { return exclusiveCats; }
        exclusive.map(type => {
            if (type.fkOptionalExtra.optionalExtraCategory === null) { return; }
            if (!this.exclusiveCategories$.has(type.fkOptionalExtra.optionalExtraCategory.id)) {
                this.exclusiveCategories$.set(
                    type.fkOptionalExtra.optionalExtraCategory.id,
                    type.fkOptionalExtra.optionalExtraCategory.category
                );
            }
            if (!exclusiveCats.has(type.fkOptionalExtra.optionalExtraCategory.id)) {
                exclusiveCats.set(type.fkOptionalExtra.optionalExtraCategory.id,
                    type.fkOptionalExtra.optionalExtraCategory.category);
            }
        }
        );
        return exclusiveCats;
    }

    fillOptionalFacilities(facilities) {
        const optionalfacilities = new Map(); // for a single hotel
        facilities.map(facility => {
            if (!this.optionalFacilities$.has(facility.fkHotelFacility.facility.id)) {
                this.optionalFacilities$.set(facility.fkHotelFacility.facility.id, facility.fkHotelFacility.facility.name);
            }
            if (!optionalfacilities.has(facility.fkHotelFacility.facility.id)) {
                optionalfacilities.set(facility.fkHotelFacility.facility.id, facility.fkHotelFacility.facility.name);
            }
        });
        return optionalfacilities;
    }

    fillMinMaxPriceNew(bookingRequest) {
        /* rooms.map( room => {
            if (room.offerPrice > this.priceRange$.maxPrice) {
                this.priceRange$.maxPrice = room.offerPrice;
            }
            if (room.offerPrice < this.priceRange$.minPrice) {
                this.priceRange$.minPrice = room.offerPrice;
            }
        }); */
        this.priceRange$.minPrice = 0;
        //     this.priceRange$.maxPrice = bookingRequest.priceRange;
        let max = 0;
        // const date1 = new Date(bookingRequest.fromDate);
        // const date2 = new Date(bookingRequest.toDate);
        // const timeDiff = Math.abs(date2.getDate() - date1.getDate());
        max = Math.max.apply(Math, this.hotePreviews.map(function (o) {
            return o.minDefaultPrice;
        }));
        //     this.priceRange$.maxPrice = 1000 ;
    }

    fillMinMaxPrice(bookingRequest) {
        /* rooms.map( room => {
            if (room.offerPrice > this.priceRange$.maxPrice) {
                this.priceRange$.maxPrice = room.offerPrice;
            }
            if (room.offerPrice < this.priceRange$.minPrice) {
                this.priceRange$.minPrice = room.offerPrice;
            }
        }); */
        this.priceRange$.minPrice = 0;
        this.priceRange$.maxPrice = bookingRequest.priceRange;
        let max = 0;
        // const date1 = new Date(bookingRequest.fromDate);
        // const date2 = new Date(bookingRequest.toDate);
        // const timeDiff = Math.abs(date2.getDate() - date1.getDate());
        max = Math.max.apply(Math, this.hotePreviews.map(function (o) {
            return o.minDefaultPrice;
        }));
        this.priceRange$.maxPrice = max;
    }

    changeHeader(headerType: string) {
        this.sharedContainer.generalState$.dispatch(new HeaderChangeAction(1, { headerType: headerType }));
    }


    getMapCenter() {
        if (this.myRequestInfo === undefined || this.myRequestInfo === null) {
            return ({ longitude: 0, latitude: 0 });
        }
        return ({
            longitude: this.myRequestInfo.longitude,
            latitude: this.myRequestInfo.latitude
        });
    }

    getHotels() {
        return this.hotePreviews;
    }
    getHotelsForMaps() {
        return this.hotePreviewsForMaps;
    }
    retrieveOffers(offerId: string) {
        this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: true }));
        this.resultsService.getOffers(offerId).subscribe(offers => {
            this.storeOffers(offers, true);
            this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: false }));
        });
    }
    retrieveOffersPaginate(offerId: string, offset, limit) {
        this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: true }));
        this.resultsService.getOffersPaginate(offerId, offset, limit).subscribe(offers => {
            if (offset !== 0) {
                this.storeOffers(offers, false);
            } else {
                this.storeOffers(offers, true);
            }
            this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: false }));
        });
    }

    sortHotelsBy(sortByOption: SortByOptions, filters = null) {
        switch (sortByOption) {
            case SortByOptions.SORT_BY_PRICE_DESC: {
                // this.sortByPrice('ASC');
                this.router.navigate([], { relativeTo: this.route, queryParams: { sortby: 'high_to_low' }, queryParamsHandling: 'merge' });
                break;
            }
            case SortByOptions.SORT_BY_PRICE_ASC: {
                // this.sortByPrice('DESC');
                this.router.navigate([], { relativeTo: this.route, queryParams: { sortby: 'low_to_high' }, queryParamsHandling: 'merge' });
                break;
            }
            case SortByOptions.SORT_BY_STARS: {
                this.sortByStars(); break;
            }
            case SortByOptions.SORT_BY_HOTEL_TYPE: {
                if (filters != null) { this.filterResults(filters); } break;
            }
            case SortByOptions.SORT_BY_MEAL_TYPE: {
                if (filters != null) { this.filterResults(filters); } break;
            }
            case SortByOptions.SORT_BY_EXCLUSIVE_CAT: {
                this.sortByExperiences(); break;
            }
            case SortByOptions.SORT_BY_EXPERIENCE: {
                if (filters != null) { this.filterResults(filters); } break;
            }
            case SortByOptions.SORT_BY_OPTIONAL_CAT: {
                this.sortByOptFacilities(); break;
            }
            default: {
                // this.sortByPrice('DESC');
                /*this.router.navigate([], { relativeTo: this.route, queryParams:
                    {pricefilter: filters.priceRange }, queryParamsHandling: 'merge' });*/
            }
        }
        this.sortBySubj.next(this.markers);
        this.hotelPrev.next(this.hotePreviews);
    }

    filterResults(filters) {
        this.filterByHotelId(filters.hotelTypes);
        this.filterByMealId(filters.mealTypes);
        this.filterByExclusiveId(filters.exclusiveCategories);
        this.filterByOptionalId(filters.optionalFacilities);
        this.filterByExperiencesId(filters.experiences);
    }

    filterByHotelId(hotelIds) {
        this.hotePreviews = hotelIds.map(id =>
            this.allHotels.filter(hotel =>
                hotel.hotelTypes.has(id)
            )
        );
        this.hotePreviews = [].concat.apply([], this.hotePreviews);
        if (this.hotePreviews.length === 0) { this.hotePreviews = this.allHotels; }
    }

    filterByMealId(ids) {
        this.hotePreviews = ids.map(id =>
            this.hotePreviews.filter(hotel =>
                hotel.mealTypes.has(id)
            )
        );
        this.hotePreviews = [].concat.apply([], this.hotePreviews);
        if (this.hotePreviews.length === 0) { this.hotePreviews = this.allHotels; }
    }

    filterByExperiencesId(ids) {

        this.hotePreviews = ids.map(id =>
            this.hotePreviews.filter(hotel =>
                hotel.experiences.find(exp => (exp.optionalExtraCategory &&
                    exp.optionalExtraCategory.id === id ? true : false)) ? true : false
            )
        );
        this.hotePreviews = [].concat.apply([], this.hotePreviews);
        if (this.hotePreviews.length === 0) { this.hotePreviews = this.allHotels; }
    }

    filterByExclusiveId(ids) {
        this.hotePreviews = ids.map(id =>
            this.hotePreviews.filter(hotel =>
                hotel.exclusiveCategories.has(id)
            )
        );
        this.hotePreviews = [].concat.apply([], this.hotePreviews);
        if (this.hotePreviews.length === 0) { this.hotePreviews = this.allHotels; }
    }

    filterByOptionalId(ids) {
        this.hotePreviews = ids.map(id => this.hotePreviews.
            filter(hotel => hotel.optionalFacilities.has(id)));

        this.hotePreviews = [].concat.apply([], this.hotePreviews);
        if (this.hotePreviews.length === 0) { this.hotePreviews = this.allHotels; }
    }

    sortByPrice(order: string) {
        let aLarger = 1;
        let bLarger = -1;
        if (order === 'DESC') { aLarger = -1; bLarger = 1; }
        this.hotePreviews.sort((a, b) => {
            if (a.minPrice > b.minPrice) { return aLarger; }
            if (a.minPrice < b.minPrice) { return bLarger; }
            return 0;
        });
    }

    sortByStars() {
        this.hotePreviews.sort((a, b) => {
            if (a.stars > b.stars) { return -1; }
            if (a.stars < b.stars) { return 1; }
            return 0;
        });
    }

    sortByExperiences() {
        this.hotePreviews.sort((a, b) =>
            (-1) * (a.experiencesPriority - b.experiencesPriority)
        );
    }

    sortByOptFacilities() {
        this.hotePreviews.sort((a, b) =>
            (a.optFacilitiesPriority - b.optFacilitiesPriority)
        );
    }

    getSingleOffer(offerId: number) {
        return this.singleResultService.getOffer(offerId);
    }

    getActivePeriodOfOptionalFacilty(hotelId: number,
        roomTypeId: number, fromDate: string, toDate: string): Observable<any> {
        return this.singleResultService.getActivePeriodOfOptionalFacilty(hotelId, roomTypeId, fromDate, toDate);
    }

    setHeaderInfo(hotelInfo: HotelHeaderInfo) {
        this.sharedContainer.generalState$.dispatch(new ChangeHotelInfo(1, { hotelHeaderInfo: hotelInfo }));
    }

    saveBookingInfo(hotelid, room): Observable<any> {
        return this.resultsService.saveBookingInfo(hotelid, room);
    }

    goBooking(hotelid, data, room): Observable<any> {
        return this.resultsService.goToBooking(hotelid, data, room);
    }

    enableSpinner(enabled) {
        this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: enabled }));
    }

    openLoginModal() {
        this.userLoggedInAfter = true;
        this.sharedContainer.generalState$.dispatch(new ToggleLoginModal(1, { loginModalOpened: true }));
    }

    getUserId() {
        const user = localStorage.getItem('user');
        return JSON.parse(user).id;
    }

    getUserLogged(): Observable<any> {
        return this.dashboard.getUser(this.getUserId());
    }

    sendRequestToHotels(bookingRequest) {
        if (bookingRequest == null || bookingRequest === undefined) { return; }
        bookingRequest.user = this.getUserId();
        this.sharedContainer.generalState$.dispatch(new SendRequest(1,
            { isRequestSendEnabled: false }));

        this.singleResultService.setBookingRequest(bookingRequest, bookingRequest.id)
            .subscribe(reply => {
                this.singleResultService.assignRequestToUser(bookingRequest.id)
                    .subscribe(r => {
                        this.isLoggedIn$ = true;
                        if (this.roomsForBooking) {
                            this.createRequest(this.offerInfo, this.offerId, this.currentTotalCost);
                        } else {
                            window.location.href = this.router.url;
                        }
                    });
            });
    }

    userLoggedInAfterRequest() {
        if (this.userLoggedInAfter) {
            // this.sendRequestToHotels(this.bookingRequest);
            if (this.roomsForBooking) {
                this.fillRequestInfoNew(this.requestForSearch);
                this.sharedContainer.generalState$.dispatch(new ChangeLasteRequestAsked(1,
                    { lastRequestAsked: this.myRequestInfo }));
                this.goToBooking(this.offerInfo, this.offerId, this.currentTotalCost);
            }
            this.userLoggedInAfter = false;
        }
    }

    disableBookingAction() {
        this.sharedContainer.generalState$.dispatch(new ChangeBookingAction(1, { isBookingActionEnabled: false }));
    }

    signupUser(user) {
        this.sharedContainer.register(user);
    }

    isMobile() {
        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }
        return false;
    }

    goBack() {
        this.location.back();
    }


    async createRequest(offerInfo, offerId, currentTotalCost) {
        if (this.isMobile() && this.roomsForBooking.size === 0) {
            this.disableBookingAction();
            const el = document.getElementById('roomList');
            el.scrollIntoView({ behavior: 'smooth' });
            document.getElementById('carouselMobile').scrollTop += 40;
            return;
        }
        if (!this.roomsForBooking || (this.roomsForBooking && this.roomsForBooking.size === 0)) {
            // window.location.href = this.router.url;
            //  this.router.navigate([this.router.url]);
            this.disableBookingAction();
            return;
        }
        const roomsForBooking = new Array();
        const observableBatch = [];
        // this.enableSpinner(true);
        await this.roomsForBooking.forEach((room, id, map) => {
            const bookingOfferRoom = offerInfo.offerRooms.find(roomOffer => roomOffer.room.id === id);
            if (bookingOfferRoom) {
                bookingOfferRoom.room.selectedRooms = room.selectedRooms;
                bookingOfferRoom.room.isSelected = true;
                // bookingOfferRoom.room.bookingOffer = bookingOfferVo

                const selectedExtras = new Array();

                room.experienceTypes.forEach((extra, key, mapp) => {
                    const selectedExtra = {
                        quantity: extra.quantity,
                        price: extra.costPerItem,
                        bookingOfferRoomId: id,
                        extraDate: null,
                        bookingOfferExtraId: key
                    };
                    selectedExtras.push(selectedExtra);
                });

                bookingOfferRoom.room.bookingOfferRoomSelectedExtras = selectedExtras;

                const selectedMeals = new Array();
                room.roomMealTypes.forEach((meal, key, mapp) => {
                    const selectedExtra = {
                        quantity: meal.quantity,
                        price: meal.costPerItem,
                        bookingOfferRoomId: id,
                        mealDate: null,
                        bookingOfferMealId: key
                    };
                    selectedMeals.push(selectedExtra);
                });

                bookingOfferRoom.room.bookingOfferRoomSelectedMeals = selectedMeals;
                bookingOfferRoom.room.bookingOffer = parseInt(offerId, 10);


                roomsForBooking.push(bookingOfferRoom);
                observableBatch.push(this.saveBookingInfo(bookingOfferRoom.room.id, bookingOfferRoom.room));

                /*this.resultsContainer.saveBookingInfo(bookingOfferRoom.room.id, bookingOfferRoom.room).subscribe(res => {
                    //this.router.navigate(['/']);
                });*/
            }
        });

        forkJoin(observableBatch).subscribe(arg => {
            // this.enableSpinner(false);
            this.disableBookingAction();
            fbq('track', 'InitiateCheckout', {
                // content_ids: this.offerInfo.hotel.id,
                content_name: offerInfo.hotel.name,
                currency: 'EUR',
                value: currentTotalCost
                // content_type: 'product_group',
                // contents: contentsFb
            });
            this.router.navigate(['/booking/' + offerId]);
            window.location.href = '/booking/' + offerId;
        });


        // const promises = this.resultsContainer.saveBookingInfo(bookingOfferRoom.room.id, bookingOfferRoom.room);

    }

    async goToBooking(offerInfo, offerId, currentTotalCost) {
        if (this.isMobile() && this.roomsForBooking.size === 0) {
            this.disableBookingAction();
            const el = document.getElementById('roomList');
            el.scrollIntoView({ behavior: 'smooth' });
            document.getElementById('carouselMobile').scrollTop += 40;
            return;
        }
        if (!this.roomsForBooking || (this.roomsForBooking && this.roomsForBooking.size === 0)) {
            // window.location.href = this.router.url;
            //  this.router.navigate([this.router.url]);
            this.disableBookingAction();
            if (!this.isMobile()) {
                const elem = <HTMLElement>document.getElementById('selectRoom');
                elem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                elem.classList.add('noRoomSelected');
            }
            return;
        }
        const roomsForBooking = new Array();
        const observableBatch = [];
        // this.enableSpinner(true);
        await this.roomsForBooking.forEach((room, id, map) => {
            const bookingOfferRoom = offerInfo.offerRooms.find(roomOffer => roomOffer.room.id === id);
            if (bookingOfferRoom) {
                bookingOfferRoom.room.selectedRooms = room.selectedRooms;
                bookingOfferRoom.room.isSelected = true;
                // bookingOfferRoom.room.bookingOffer = bookingOfferVo

                const selectedExtras = new Array();

                room.experienceTypes.forEach((extra, key, mapp) => {
                    const selectedExtra = {
                        quantity: extra.quantity,
                        price: extra.costPerItem,
                        bookingOfferRoomId: id,
                        extraDate: null,
                        bookingOfferExtraId: key
                    };
                    selectedExtras.push(selectedExtra);
                });

                bookingOfferRoom.room.bookingOfferRoomSelectedExtras = selectedExtras;

                const selectedMeals = new Array();
                room.roomMealTypes.forEach((meal, key, mapp) => {
                    const selectedExtra = {
                        quantity: meal.quantity,
                        price: meal.costPerItem,
                        bookingOfferRoomId: id,
                        mealDate: null,
                        bookingOfferMealId: key
                    };
                    selectedMeals.push(selectedExtra);
                });

                bookingOfferRoom.room.bookingOfferRoomSelectedMeals = selectedMeals;
                bookingOfferRoom.room.bookingOffer = this.myRequestInfo.userid;


                roomsForBooking.push(bookingOfferRoom);
                observableBatch.push(this.goBooking(bookingOfferRoom.room.id, this.requestForSearch, bookingOfferRoom.room));

                /*this.resultsContainer.saveBookingInfo(bookingOfferRoom.room.id, bookingOfferRoom.room).subscribe(res => {
                    //this.router.navigate(['/']);
                });*/
            }
        });

        forkJoin(observableBatch).subscribe(arg => {
            // this.enableSpinner(false);
            this.disableBookingAction();
            fbq('track', 'InitiateCheckout', {
                // content_ids: this.offerInfo.hotel.id,
                content_name: offerInfo.hotel.name,
                currency: 'EUR',
                value: currentTotalCost
                // content_type: 'product_group',
                // contents: contentsFb
            });
            this.router.navigate(['/booking/' + offerId]);
            // window.location.href = '/booking/' + offerId;
        });


        // const promises = this.resultsContainer.saveBookingInfo(bookingOfferRoom.room.id, bookingOfferRoom.room);

    }
    getRoomsForBooking() {
        return this.roomsForBooking;
    }

}

export interface HotelPreview {
    minPrice;
    minDefaultPrice?;
    title;
    description;
    pictures;
    stars;
    reviews;
    experiences;
    experiencesSortByAPrice?;
    optionaRequests;
    id?: number;
    hotelTypes?: Map<number, string>;
    mealTypes?: Map<number, string>;
    exclusiveCategories?: Map<number, string>;
    optionalFacilities?: Map<number, string>;
    offerId: number;
    offerType: string;
    experiencesAvailable?: string;
    optionalAvailable?: string;
    experiencesPriority?: number;
    optFacilitiesPriority?: number;
    personalRequestIcon?: string;
    hasDiscount?: boolean;
    offerNote?;
    expiring?;
    requestInfo?;
    hasTick?;
    lat?;
    long?;
    filterMatch?: boolean;
    wishesSatisfied?: String;
    hotelierName?: String;
    hotelier?: Hotelier;
    isAvailable?: boolean;
}
